export const updateExpandedSection = (field, value, currentEl, prevEl) => {
  const elements = document.querySelectorAll(field ? '.expanded-users' : '.expanded-contacts')
  for (let i = 0; i <= elements.length - 1; i++) {
    if (value) {
      if (elements[i].getAttribute('data-info') === currentEl) {
        elements[i].classList.remove('d-none')
      } else {
        elements[i].classList.add('d-none')
      }
    } else {
      if (elements[i].getAttribute('data-info') === currentEl) {
        elements[i].classList.add('d-none')
        if (prevEl >= 0 && currentEl !== prevEl) {
          elements[i].classList.remove('d-none')
        } else {
          elements[i].classList.add('d-none')
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ClientContacts/helpers.js